<template>
  <div class="headerTop flex">
    <div style="flex: 1">
      <img class="img" src="../../assets/imges/JD963774380491.png" alt="" />
    </div>
    <div style="flex: 2.5">
      <div
        v-for="(item, index) in router"
        :key="index"
        class="router"
        @click="choose(index)"
      >
        <router-link
          :to="item.url"
          class="link"
          :class="[item.url, { active: current == index }]"
          >{{ item.name }}</router-link
        >
      </div>
      <div class="login">
        <span>
          <router-link v-if="token == ''" class="link" to="/login">
            登录
          </router-link>
          <router-link  v-else class="link" to="/my">
            <img v-if="loginNmae!=''" style="width: 50px;border-radius: 50%;" :src="loginNmae" alt="" />
            <span v-else>会员中心</span>
          </router-link>
        </span>
        <!-- <span>
          <router-link to="/registered"
                       class="link">新用户注册</router-link>
        </span>
        <span>
          <router-link to="/ForgotPassword"
                       class="link">忘记密码</router-link>
        </span> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hidden: false,
      loginNmae: "",
      token:"",
      current: window.sessionStorage.getItem("index"),
      router: [
        { url: "/", name: "首页" },
        { url: "/OnlineInvoicing", name: "在线计价" },
        { url: "/CompanyStrength", name: "公司展示" },
        { url: "/companyShows", name: "制作工艺" },
        { url: "/product", name: "公司产品" },
        { url: "/mall", name: "积分商城" },
        { url: "/AboutUs", name: "关于我们" },
        { url: "/contact", name: "联系我们" },
      ],
    };
  },
  created() {
    window.sessionStorage.setItem("index", 0);
    if (window.sessionStorage.getItem("token")) {
      this.loginNmae = window.sessionStorage.getItem("Avatar");
      this.token=window.sessionStorage.getItem('tokne')
    }
    this.current = window.sessionStorage.getItem("index");
  },
  methods: {
    choose(index) {
      window.sessionStorage.setItem("index", index);
      this.current = window.sessionStorage.getItem("index");
    },
  },
};
</script>
<style lang="scss" scoped>
//   登录前

.active {
  background: url(../../assets/imges/cur.jpg) no-repeat center 0 #4aaf3d;
  float: left;
  position: relative;
  height: 104px;
  line-height: 104px;
  color: #fff;
  display: block;
  
  font-size: 16px;
  height: 104px;
  padding: 0 17px;
}
img {
  width: 10rem;
}
.headerTop {
  background-image: url(../../assets/imges/t_bg.jpg);
  background-size: 100%;
  width: 100%;
  height: 100px;
  .img {
    position: absolute;
    left: 10%;
    top: 40%;
  }
  .login {
    color: #000;
    .link {
      font-style: unset;
      float: left;
      position: relative;
      height: 6.5rem;
      line-height: 6.5rem;
      display: block;
      font-size: 1rem;
      height: 6.5rem;
      padding: 0 1.0625rem;
      color: #000;

      // color: #ffffff;
    }
  }
  .login span :hover {
    color: #f00;
  }

  position: relative;
  text-align: center;
  ///background-color: #000;
  // background-image: url(../../assets/imges/26.png);
  // background: #2bae85;
  background-repeat: no-repeat;
  background-size: 100%;
  opacity: 0.8;
  padding-top: 1rem;
  height: 9rem;
  width: 100%;
  margin-bottom: 1rem;
  justify-content: left;
  align-content: center;
  div {
    .router {
      float: left;
      font-style: unset;
      margin-right: 10px;
      color: #000;
      .link:hover {
        background: url(../../assets/imges/cur.jpg) no-repeat center 0 #4aaf3d;
        float: left;
        position: relative;
        height: 104px;
        line-height: 104px;
        display: block;
        font-size: 16px;
        height: 104px;
        padding: 0 17px;
        // background-image: url(../../assets/imges/41.png);
        // background-size: 100%;
        // border: 0.1rem solid #ffffff;
        // border-radius: 0.3rem;
        // color: #007aff;
      }
      .link {
        font-style: unset;
        float: left;
        position: relative;
        height: 6.5rem;
        line-height: 6.5rem;
        display: block;
        font-size: 1rem;
        height: 6.5rem;
        padding: 0 1.0625rem;
        color: #000;

        // color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GlobalComponents/header.vue